var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _polygon, _rect, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinScreenTemp01 = function SvgMinScreenTemp01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12.83,
    y1: 169.75,
    x2: 161.72,
    y2: 4.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -6.83,
    y1: 152.06,
    x2: 142.06,
    y2: -13.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -37.34,
    y1: 124.61,
    x2: 111.56,
    y2: -40.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -25.78,
    y1: 135,
    x2: 123.11,
    y2: -30.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3.39,
    y1: 161.26,
    x2: 152.28,
    y2: -4.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 7.92,
    y1: 165.34,
    x2: 156.82,
    y2: -0.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -22.64,
    y1: 137.84,
    x2: 126.26,
    y2: -27.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 48.97,
    y1: 202.27,
    x2: 197.86,
    y2: 36.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 37.98,
    y1: 192.38,
    x2: 186.87,
    y2: 26.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 57.98,
    y1: 210.38,
    x2: 206.87,
    y2: 44.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 54.97,
    y1: 207.68,
    x2: 203.87,
    y2: 42.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 70.5,
    y1: 221.65,
    x2: 219.4,
    y2: 56.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 84.64,
    y1: 234.37,
    x2: 233.53,
    y2: 68.91,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M160.88,15.21c.87-.9.85-2.34-.05-3.22-.9-.87-2.35-.85-3.22.05l-118.36,118.36c-.43.43-.67,1-.67,1.61,0,1.26,1.02,2.28,2.28,2.28.6,0,1.18-.24,1.61-.67L160.83,15.27s.04-.04.05-.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.55,95.7c.42.43,1.01.68,1.61.68h0c.59-.01,1.16-.25,1.58-.66.9-.88.91-2.32.03-3.22-6.95-7.06-10.81-16.59-10.72-26.49,0-20.08,15.32-36.42,34.14-36.42,10.16.07,19.74,4.79,25.99,12.8.78.93,2.15,1.08,3.12.35,1-.76,1.2-2.19.44-3.19-7.11-9.1-18-14.44-29.55-14.51-21.34,0-38.69,18.38-38.69,40.97-.09,11.1,4.24,21.79,12.04,29.69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.18,31.2c.43.43,1.01.67,1.61.67s1.18-.24,1.61-.67c.89-.89.89-2.33,0-3.22l-9.1-9.1c-.88-.85-2.28-.85-3.16,0-.9.87-.93,2.31-.05,3.22l9.1,9.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.41,66.01c0-1.26-1.02-2.28-2.28-2.28h-13.66c-1.26,0-2.28,1.02-2.28,2.28s1.02,2.28,2.28,2.28h13.66c1.26,0,2.28-1.02,2.28-2.28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47.68,113.81c.6,0,1.18-.24,1.61-.67l9.1-9.11c.85-.88.85-2.28,0-3.16-.87-.9-2.31-.93-3.22-.06l-9.1,9.1c-.43.43-.67,1.01-.67,1.61,0,1.26,1.02,2.28,2.28,2.28"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M129.62,31.87c.6,0,1.18-.24,1.61-.67l9.1-9.11c.85-.88.85-2.28,0-3.16-.87-.9-2.31-.93-3.22-.06l-9.1,9.1c-.43.43-.67,1.01-.67,1.61,0,1.26,1.02,2.28,2.28,2.28"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M93.21,18.21c1.26,0,2.28-1.02,2.28-2.28V2.28C95.48,1.02,94.46,0,93.21,0s-2.28,1.02-2.28,2.28v13.66c0,1.26,1.02,2.28,2.28,2.28"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.39,112.81c-.72-1.03-2.14-1.28-3.17-.56-5.11,3.59-11.21,5.51-17.46,5.49-16.47.11-29.93-13.12-30.08-29.59,0-4.98,1.27-9.87,3.68-14.21.3-.55.37-1.19.18-1.78-.38-1.2-1.65-1.87-2.85-1.49-16.34,4.99-27.4,20.19-27.13,37.27.34,21.18,17.77,38.07,38.95,37.73,18.55.08,34.57-12.95,38.26-31.13.12-.61-.01-1.23-.37-1.74M135.24,141.12c-19.05.36-34.78-14.79-35.14-33.84.01-12.87,7.35-24.6,18.91-30.25-1.25,3.58-1.88,7.34-1.88,11.13.16,18.98,15.65,34.26,34.64,34.14,5.21.01,10.36-1.14,15.06-3.39-5.01,13.15-17.51,21.93-31.58,22.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M145.56,79.67c1.26,0,2.28-1.02,2.28-2.28v-2.28h2.28c1.26,0,2.28-1.02,2.28-2.28s-1.02-2.28-2.28-2.28h-2.28v-2.28c0-1.26-1.02-2.28-2.28-2.28s-2.28,1.02-2.28,2.28v2.28h-2.28c-1.26,0-2.28,1.02-2.28,2.28s1.02,2.28,2.28,2.28h2.28v2.28c0,1.26,1.02,2.28,2.28,2.28"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.49,91.05c0-1.26-1.02-2.28-2.28-2.28s-2.28,1.02-2.28,2.28v4.55h-4.55c-1.26,0-2.28,1.02-2.28,2.28s1.02,2.28,2.28,2.28h4.55v4.55c0,1.26,1.02,2.28,2.28,2.28s2.28-1.02,2.28-2.28v-4.55h4.55c1.26,0,2.28-1.02,2.28-2.28s-1.02-2.28-2.28-2.28h-4.55v-4.55Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "52.98 200 60.17 163 66.33 163 74.92 185.65 83.53 163 89.69 163 96.88 200 89.43 200 85.33 178.78 77.43 199.63 72.41 199.63 64.53 178.78 60.41 200 52.98 200"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 102.99,
    y: 163,
    width: 7.29,
    height: 37
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.42 200 117.42 163 125.29 163 139.72 186.81 139.72 163 147.02 163 147.02 200 139.14 200 124.71 176.19 124.71 200 117.42 200"
  })));
};
export default SvgMinScreenTemp01;